import { render, staticRenderFns } from "./shareAgreementEdit.vue?vue&type=template&id=21d80f55&scoped=true"
import script from "./shareAgreementEdit.vue?vue&type=script&lang=js"
export * from "./shareAgreementEdit.vue?vue&type=script&lang=js"
import style0 from "./shareAgreementEdit.vue?vue&type=style&index=0&id=21d80f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d80f55",
  null
  
)

export default component.exports